export default __webpack_public_path__ + "static/media/9.6f36b179.jpg";